import tokenApi from '@/api/token';
import wXAppUserAPI from '@/api/wXAppUser.js';
import { setCookie, removeCookie, tokenUtil } from '@/utils/cookie';
import { localTokenUtil } from '@/utils/localStorageHelper';
const USER_CACHE_KEY = 'APOLLO_STUDENT_USER';
const GET_OPENID_STATUS = "GET_OPENID_STATUS";
const Handler = {
  getUser: function () {
    var cache = sessionStorage.getItem(USER_CACHE_KEY);
    if (cache) {
      var user = JSON.parse(cache);
      return user;
    }
    return null;
  }
};

const state = {
  // [qupei, org]
  rootType: '',
  orgid: '',
  openid: '',
  payopenid: '',
  studentid: 0,
  // 是否绑定了openId, 绑定了才能用于 openid 登录
  isBindOpenId: !1,
  // 会员信息
  userInfo: null,
  // 学员信息
  studentInfo: null,
  // 登录信息
  loginInfo: null,
  orgList: [
    {
      Name: '',
      LogoUrl: '',
      OrgId: ''
    }
  ]
};

const getters = {
  /**
   * 登录用户信息
   * @param {*} state
   */
  loginUser (state) {
    if (state.userInfo) {
      return state.userInfo;
    }
    return Handler.getUser();
  },
  studentInfo (state) {
    if (state.studentid) {
      return state.studentid;
    }
  }
};
const mutations = {
  /**
   * 设置根
   * @param {*} state
   * @param {*} payload
   */
  SET_ROOT (state, payload) {
    state.rootType = payload.root;
    if (payload.orgid) state.orgid = parseFloat(payload.orgid);
  },
  /**
   * 设置基本参数
   * @param {*} state
   * @param {*} payload
   */
  SET_BASE (state, payload) {
    if (payload) {
      if (payload.orgid) state.orgid = parseFloat(payload.orgid);
      if (payload.openid) state.openid = payload.openid;
      if (payload.payopenid) state.payopenid = payload.payopenid;
      if (payload.studentid) state.studentid = parseFloat(payload.studentid);
    }
  },
  /**
   * 设置当前学生基本信息
   * @param {*} state
   * @param {*} payload
   */
  SET_STUDENT (state, payload) {
    if (payload && payload.studentInfo) {
      state.studentInfo = payload.studentInfo;
      state.studentid = payload.studentInfo.StudentId;
    }
  },
  SET_HAS_ORG (state, payload) {
    if (payload.orgList && payload.orgList.length > 0) {
      state.orgList = payload.orgList;
    }
    if (payload.phone && payload.verifycode) {
      state.loginInfo = {
        phone: payload.phone,
        verifycode: payload.verifycode
      };
    }
    if (payload.orgid) {
      state.loginInfo.orgid = parseFloat(payload.orgid);
      state.orgid = parseFloat(payload.orgid);
    }
  },
  /**
   * 退出
   * @param {*} state
   * @param {*} payload
   */
  LOGIN_OUT (state, payload) {
    state.userInfo = null;
    state.openid = null;
    state.orgid = '';
    state.payopenid = '';
    state.studentid = 0;
    state.studentInfo = null;
  },
  /**
   *
   * @param {*} state
   * @param {*} payload
   */
  LOGIN_SCCUESS (state, payload) {
    state.userInfo = payload.userInfo;
    sessionStorage.setItem(USER_CACHE_KEY, JSON.stringify(payload.userInfo));
  },
  /**
   * 设置openid
   * @param {*} state
   * @param {*} payload
   */
  SET_OPENID (state, payload) {
    state.openid = payload.openid;
  }
};
const actions = {
  /**
   *
   * @param {*} context
   * @param {*} payload
   */
  setBase (context, payload) {
    return new Promise((resolve, reject) => {
      if (payload && payload.orgid > 0) {
        tokenUtil.setorg(payload.orgid);
        localTokenUtil.setorg(payload.orgid);
      }
      context.commit('SET_BASE', payload);
      resolve(payload);
    });
  },
  /**
   * 检测登录（用于登录页面）
   * @param {*} context
   * @param {*} payload
   */
  checkLogin (context, payload) {
    // 检测 token 是否过期
    let orgid =
      context.state.orgid !== 0 ? context.state.orgid : tokenUtil.getorg() || 0;
    context.commit('SET_BASE', { orgid: orgid });
    var token = tokenUtil.get(orgid);
    if (token) {
      // 尝试获取用户信息
      return context.dispatch('loginSuccess');
    } else if (context.state.openid !== '' || context.state.openid !== '0') {
      // 尝试通过appid登录
      return context.dispatch('loginByOpenId');
    }
    // return Promise.resolve();
  },
  /**
   *  账号登录
   * @param {*} context
   * @param {*} payload
   */
  loginByAccount (context, payload) {
    // 是否 绑定账号，免登录
    return wXAppUserAPI
      ._getOrgListByPhone({
        phone: payload.phone,
        verifycode: payload.verifycode
      })
      .then(res => {
        context.commit('SET_HAS_ORG', {
          orgList: res,
          phone: payload.phone,
          verifycode: payload.verifycode
        });
        return res;
      });
  },
  /**
   * 账号密码登录
   * @param {*} context
   * @param {*} payload
   */
  loginByPassword (context, payload) {
    return wXAppUserAPI
      ._getOrgListByPassword({
        phone: payload.phone,
        password: payload.password
      })
      .then(res => {
        context.commit('SET_HAS_ORG', {
          orgList: res,
          phone: payload.phone
        });
        return res;
      });
  },
  /**
   *
   * openid 登录
   * @param {*} context
   * @param {*} payload
   */
  getTokenByOpenId (context, payload) {
    context.commit('SET_BASE', payload);
    return tokenApi
      ._getToken({
        openid: payload.openid
      })
      .then(res => {
        context.dispatch('loginSuccess', {
          token: res
        });
      });
  },
  /**
   *
   * openid 登录
   * @param {*} context
   * @param {*} payload
   */
  loginByOpenId (context, payload) {
    return tokenApi
      ._getToken({
        openid: context.state.openid
      })
      .then(res => {
        return context.dispatch('loginSuccess', {
          token: res
        });
      });
  },
  /**
   * 登录成功
   * @param {*} context
   * @param {*} payload
   */
  loginSuccess (context, payload) {
    // 设置 token
    if (payload) {
      tokenUtil.set(payload.token, context.state.orgid);
      localTokenUtil.set(payload.token, context.state.orgid);
      var studentInfo = tokenUtil.getStudent(context.state.orgid);
      if (!!studentInfo) {
        context.commit('SET_STUDENT', {
          studentInfo: JSON.parse(studentInfo)
        });
        context.commit('SET_BASE', {
          studentid: JSON.parse(studentInfo).StudentId
        });
      }
    }
    return context.dispatch('getUserInfo');
  },
  /**
   * 获取用户(会员)信息
   * @param {*} context
   * @param {*} payload
   */
  getUserInfo (context, payload) {
    let token = tokenUtil.get(context.state.orgid);
    if (context.state.userInfo != null) {
      return Promise.resolve(!0);
    } else if (token) {
      return wXAppUserAPI._getUserInfo().then(res => {
        context.commit('LOGIN_SCCUESS', {
          userInfo: res
        });
        if (res.OrgId !== context.state.orgid) {
          // 发现orgid更改重新绑定token
          tokenUtil.set(token, res.OrgId);
          localTokenUtil.set(token, res.OrgId);
          tokenUtil.remove(context.state.orgid);
          localTokenUtil.remove(context.state.orgid);
          context.dispatch('setBase', {
            orgid: res.OrgId
          });
        }
        return Promise.resolve(!0);
      });
    } else return Promise.resolve(!1);
  },
  currentStudent (context, payload) {
    var currentStudent = null;
    if (context.state.studentInfo) currentStudent = context.state.studentInfo;
    else {
      var Student = tokenUtil.getStudent(context.state.orgid);
      if (Student) {
        currentStudent = JSON.parse(Student);
      }
    }
    if (currentStudent) {
      context.commit('SET_STUDENT', {
        studentInfo: currentStudent
      });
      context.commit('SET_BASE', {
        studentid: currentStudent.StudentId
      });
    }
    return currentStudent;
  },
  bingCurrentStudent (context, payload) {
    payload.studentInfo = Object.assign(
      {},
      context.state.studentInfo,
      payload.studentInfo
    );

    if (payload) {
      if (!payload.studentInfo.ImgUrl) {
        payload.studentInfo.ImgUrl = 'static/Images/nosex.png';
      }
      context.commit('SET_STUDENT', {
        studentInfo: payload.studentInfo
      });
      context.commit('SET_BASE', {
        studentid: payload.studentInfo.StudentId
      });
      tokenUtil.setStudent(
        JSON.stringify(payload.studentInfo),
        context.state.orgid
      );
      localTokenUtil.setStudent(
        JSON.stringify(payload.studentInfo),
        context.state.orgid
      );
      return Promise.resolve(!0);
    } else {
      return Promise.resolve(!1);
    }
  },
  bindStudentByPhone (context, payload) {
    return wXAppUserAPI
      ._bindStudentByPhone({
        phone: payload.phone,
        verifycode: payload.verifycode,
        orgid: payload.orgid
      })
      .then(res => {
        return context.dispatch('getUserInfo');
      });
  },
  bindStudentByPassword (context, payload) {
    return wXAppUserAPI
      ._bindStudentByPassword({
        phone: payload.phone,
        password: payload.password,
        orgid: payload.orgid
      })
      .then(res => {
        return context.dispatch('getUserInfo');
      });
  },
  /**
   * 加载缓存信息（用于刷新时）
   * 所有 Store 缓存数据从这里分发加载
   * @param {*} context
   * @param {*} payload
   */
  refreshLoadCache (context, payload) {
    console.log('RefreshLoadCache-tigger');
    // 其他模块这里只做分发操作
    if (context.state.userInfo == null) {
      var userCache = Handler.getUser();
      if (userCache) {
        context.commit('LOGIN_SCCUESS', {
          userInfo: userCache
        });
      }
    }
    if (context.state.studentInfo == null) {
      var studentinfo = tokenUtil.getStudent(context.state.orgid);
      var studentCache = studentinfo ? JSON.parse(studentinfo) : null;
      if (studentCache && !studentCache.ImgUrl) {
        studentCache.ImgUrl = 'static/images/nosex.png';
      }
      context.commit('SET_STUDENT', {
        studentInfo: studentCache
      });
    }
  },
  loginOut (context, payload) {
    sessionStorage.removeItem(USER_CACHE_KEY);
    sessionStorage.removeItem(GET_OPENID_STATUS);
    removeCookie('apollo_openid_' + process.env.API_ENV_TAG, this.openid);
    setCookie('apollo_loginOut_' + process.env.API_ENV_TAG, true);
    tokenUtil.removeorg();
    localTokenUtil.removeorg();
    tokenUtil.remove(context.state.orgid);
    localTokenUtil.remove(context.state.orgid);
    tokenUtil.removeStudent(context.state.orgid);
    localTokenUtil.removeStudent(context.state.orgid);
    localTokenUtil.removeUsePasswordLogin();
    context.commit('LOGIN_OUT');
    
    // 其他模块 缓存清理分发
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/token.js